import { RouteConfig } from "vue-router";

export const RCandidatesBrowse: RouteConfig = {
  path: "",
  name: "Candidates",
  component: () =>
    import(
      /* webpackChunkName: "teammates-browse" */
      "./VCandidatesBrowse.vue"
    ),
  meta: {
    title: "Candidates",
  },
};
